(function () {
  /**
   * New Footer
   */
  class MenuAccordion extends HTMLElement {
    constructor() {
      super();

      this.onClickListener = this._onClick.bind(this);
    }
    connectedCallback() {
      this.querySelector('.new-footer__menu-title').addEventListener('click', this.onClickListener);
    }
    _open() {
      this.classList.add('open');
    }
    _close() {
      this.classList.remove('open');
    }
    _isOpened() {
      return this.classList.contains('open') === true;
    }
    _onClick(e) {
      e.preventDefault();

      if (window.innerWidth < 1024) {
        if (this._isOpened()) {
          this._close();
        } else {
          this._open();
        }
      }
    }
  }
  if (!window.customElements.get('menu-accordion')) {
    window.customElements.define('menu-accordion', MenuAccordion);
  }

  /*
   * X Timer
   */
  class XTimer extends HTMLElement {
    constructor() {
      super();

      this._endAt = this.getAttribute('end-at');
      this._days = this.querySelector('.x-timer__value--days');
      this._hours = this.querySelector('.x-timer__value--hours');
      this._minutes = this.querySelector('.x-timer__value--minutes');
      this._seconds = this.querySelector('.x-timer__value--seconds');
    }
    connectedCallback() {
      this._run();
    }
    _run() {
      try {
        if (typeof this._endAt === 'undefined' || this._endAt === '') {
          throw new Error('End time is requried.');
        }

        const endTimestamp = new Date(this._endAt * 1000).getTime();
        const intervalTime = setInterval(() => {
          const currentTimestamp = Date.now();
          const delta = endTimestamp - currentTimestamp;
          const days = Math.floor(delta / (1000 * 60 * 60 * 24));
          const hours = Math.floor((delta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((delta % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((delta % (1000 * 60)) / 1000);

          if (delta <= 0) {
            clearInterval(intervalTime);
            this.classList.add('x-tiemr--finished');
            return;
          }

          if (this._days !== null) {
            this._days.innerHTML = ('0' + days).slice(-2);

            if (days === 0) {
              this._days.style.display = 'none';
            } else {
              this._days.style.display = 'grid';
            }
          }

          this._hours.innerHTML = ('0' + hours).slice(-2);
          this._minutes.innerHTML = ('0' + minutes).slice(-2);
          this._seconds.innerHTML = ('0' + seconds).slice(-2);
        }, 1000);
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('x-timer')) {
    window.customElements.define('x-timer', XTimer);
  }

  class CheckoutButton extends HTMLElement {
    constructor() {
      super();

      this.lock = false;
      this.variantId = this.getAttribute('variant');
    }
    connectedCallback() {
      this.addEventListener('click', this._buyNow.bind(this));
    }
    async _buyNow(e) {
      e.preventDefault();

      if (!this.variantId) {
        return;
      }

      if (this.lock == true) {
        return;
      }

      try {
        this.lock = true;

        this.classList.add('loading');

        await fetch('/cart/add.js', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: this.variantId,
            quantity: 1,
          }),
        })
          .then(async (response) => {
            if (response.ok) {
              document.documentElement.classList.toggle('invisible');
              setTimeout(() => {
                window.location.href = '/checkout';
              }, 300);
            } else {
              const data = await response.json();
              console.error(data);
              this.lock = false;
            }
          })
          .catch((err) => console.error(err));
      } catch (err) {
        console.error(err);
        this.lock = false;
      }
    }
  }
  if (!window.customElements.get('checkout-button')) {
    window.customElements.define('checkout-button', CheckoutButton);
  }
})();
